// style dependencies
import '../../modal-container/style';
